export default "__VITE_ASSET__74df9836__"